import React, { useState } from 'react';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

function WeeklyBooking({ onSubmit }) {
  const [slots, setSlots] = useState(() =>
    days.reduce((acc, day) => {
      acc[day] = { start: '', end: '' };
      return acc;
    }, {})
  );
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (day, field, value) => {
    setSlots((prev) => ({
      ...prev,
      [day]: { ...prev[day], [field]: value },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (onSubmit) onSubmit(slots);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 500, margin: '32px auto', padding: 24, background: '#f6f8fa', borderRadius: 8, boxShadow: '0 2px 8px #eee' }}>
      <h2 style={{ marginBottom: 20 }}>Book Weekly Hours for Hire</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 20 }}>
        <thead>
          <tr style={{ background: '#e3eaf2' }}>
            <th style={{ padding: 8, textAlign: 'left', fontWeight: 600 }}>Day</th>
            <th style={{ padding: 8, textAlign: 'center', fontWeight: 600 }}>Start Time</th>
            <th style={{ padding: 8, textAlign: 'center', fontWeight: 600 }}>End Time</th>
          </tr>
        </thead>
        <tbody>
          {days.map((day) => (
            <tr key={day}>
              <td style={{ padding: 8 }}>{day}</td>
              <td style={{ padding: 8 }}>
                <input
                  type="time"
                  value={slots[day].start}
                  onChange={e => handleChange(day, 'start', e.target.value)}
                  style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid #ccc' }}
                />
              </td>
              <td style={{ padding: 8 }}>
                <input
                  type="time"
                  value={slots[day].end}
                  onChange={e => handleChange(day, 'end', e.target.value)}
                  style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid #ccc' }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="submit" style={{ padding: '10px 24px', borderRadius: 4, background: '#1976d2', color: '#fff', border: 'none', fontWeight: 600, cursor: 'pointer' }}>
        Book Hours
      </button>
      {submitted && (
        <div style={{ marginTop: 20, color: '#388e3c', fontWeight: 500 }}>
          Booking submitted!
        </div>
      )}
    </form>
  );
}

export default WeeklyBooking;
